import store from '@/store/store';

export default class PopupController {
  private static STORE_MUTATION_NAME = 'controlPopUp';
  public  static CP_POPUP_MODES = {
    normal: 'normal',
    afterResetPassword: 'afterResetPassword',
    confirmationReset: 'confirmationReset',
  };
  public static POPUP_NAMES = {
    CHANGE_PASSWORD: 'changePassword',
    RESET_PASSWORD: 'resetPassword',
    CONFIRM_PASSWORD: 'confirmPassword',
  }

  /**
   * Função destinada ao controle das variáveis de Popup armazenadas na store
   * 
   * @param any properties
   */
  private static controlPopupViaStore(properties: any) {
    store.commit(this.STORE_MUTATION_NAME, properties);
  }

  public static openPopup(popUpName: string, data: any = {}, isNotClosePopup = false) {
    this.controlPopupViaStore({isVisible: true, popUp: popUpName, data, isNotClosePopup});
  }

  public static closePopup(popUpName: string) {
    this.controlPopupViaStore({isVisible: false, popUp: popUpName});
  }

  /**
   * Rotina para abrir o popUp de alteração de senha
   * 
   * @param any defaultRow
   */
  public static openChangePasswordPopUp(defaultRow: any = null) {
    let popUpMode = this.CP_POPUP_MODES.normal;
    if (defaultRow) {
      popUpMode = this.CP_POPUP_MODES.afterResetPassword;
    }

    const data: any = {
      mode: popUpMode,
    }
    data.defaultRow = defaultRow;

    this.openPopup(this.POPUP_NAMES.CHANGE_PASSWORD, data);
  }

  /**
   * Rotina para abrir o popUp de confirmação de dados para a atualização de senha
   * 
   * @param any defaultRow
   */
   public static openConfirmationResetPasswordPopUp(defaultRow: any = null) {
    const popUpMode = this.CP_POPUP_MODES.confirmationReset;

    const data: any = {
      mode: popUpMode,
    }
    data.defaultRow = defaultRow;

    this.openPopup(this.POPUP_NAMES.CHANGE_PASSWORD, data);
  }

  /**
   * Rotina para abrir o popUp de redefinição de senha
   * 
   */
  public static openResetPasswordPopUp(defaultRow: any = null) {
    const data: any = {};
    data.defaultRow = defaultRow;
    this.openPopup(this.POPUP_NAMES.RESET_PASSWORD, data);
  }

  public static openConfirmPasswordPopUp(defaultRow: any = null, isNotClosePopup = false) {
    const data: any = {};
    data.defaultRow = defaultRow;
    this.openPopup(this.POPUP_NAMES.CONFIRM_PASSWORD, data, isNotClosePopup);
  }
}